var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarkerYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.838,
    height: 39.853,
    viewBox: "0 0 32.838 39.853",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e6b30f;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.351,23.663A6.94,6.94,0,0,0,23.3,16.711a7.154,7.154,0,0,0-6.953-7.2A6.94,6.94,0,0,0,9.4,16.462,7.329,7.329,0,0,0,16.351,23.663ZM4.681,4.792A16.5,16.5,0,1,1,28.021,28.132L16.351,39.8,4.681,28.132A16.955,16.955,0,0,1,4.681,4.792Z",
    transform: "translate(-0.025 0.05)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerYellow);
export default __webpack_public_path__ + "static/media/mapMarkerYellow.ec68a9cb4eee5596f15d4b003061cbe7.svg";
export { ForwardRef as ReactComponent };